var wasScrolledDown = ($(window).scrollTop() > 20);
if (wasScrolledDown) {
    jQuery("body").addClass("scrolled");
}



jQuery( window ).scroll(function() {
    var isScrolledDown = ($(window).scrollTop() > 20);

    if (isScrolledDown && !wasScrolledDown) {
        jQuery("body").addClass("scrolled");
    } else if (!isScrolledDown && wasScrolledDown) {
        jQuery("body").removeClass("scrolled");
    }

    wasScrolledDown = isScrolledDown;
});